import { FilterModel } from "src/app/@core/models/filter.model";

export class DisplayInHomeFilterModel extends FilterModel {
    showInHome: boolean = true;
    enablePagination: boolean = false;
    constructor () {
        super(1, 4)
    }
}
